import React from 'react';

interface ErrorBannerProps {
  message: string | null;
}

const ErrorBanner: React.FC<ErrorBannerProps> = ({ message }) => {
  if (!message) return null;

  return <div className="error-message">{message}</div>;
};

export default ErrorBanner;

